import router from '@/router';
import authService from '@/services/Auth';
import { errorLog } from '@/utils/logger';
import isBoolean from 'lodash/isBoolean';

export default {
  fetchAccessToken({ commit }) {
    commit('UPDATE_ACCESS_TOKEN', localStorage.getItem('accessToken'));
  },

  login({ commit }, token) {
    return new Promise((resolve, reject) => {
      try {
        const user = authService.getUserFromToken(token);

        commit('LOGIN', token);
        localStorage.setItem('accessToken', token);
        commit('dashboard/SET_WORKSPACES', [user], {
          root: true,
        });

        resolve(token);
      } catch (err) {
        errorLog(err);
        reject(err);
      }
    });
  },

  logout({ commit }) {
    localStorage.removeItem('accessToken');
    commit('LOGOUT');
    router.push('/logout');
  },

  fetchConfigs: async ({ commit }) => {
    try {
      const response = await authService.getUserConfigs();
      commit('SET_USER_CONFIGS', response.data || null);
      return Promise.resolve(response);
    } catch (err) {
      errorLog(err);
      return Promise.reject(err);
    }
  },

  fetchUserServiceProfile: async ({ commit }) => {
    try {
      const response = await authService.getServiceProfile();
      commit('SET_USER_SERVICE_PROFILE', response.data.object || null);
      return Promise.resolve(response);
    } catch (err) {
      errorLog(err);
      return Promise.reject(err);
    }
  },

  setMultilogin({ rootGetters }, hasMultilogin) {
    const { id } = rootGetters['dashboard/currWorkspace'],
      multiloginData = JSON.parse(localStorage.getItem('multiloginData')) || {};

    if (!id) return;

    Object.assign(multiloginData, { [id]: hasMultilogin });
    localStorage.setItem('multiloginData', JSON.stringify(multiloginData));
  },

  fetchMultilogin({ commit, rootGetters }) {
    const { id } = rootGetters['dashboard/currWorkspace'],
      multiloginData = JSON.parse(localStorage.getItem('multiloginData')) || {};

    const hasMultilogin = multiloginData[id];

    if (!isBoolean(hasMultilogin)) return;

    commit('UPDATE_MULTILOGIN', hasMultilogin);
  },
};
